import styled from '@emotion/styled';

export const ToggleWrapper = styled.div`
  && {
    margin-right: auto;
    margin-left: 0;
  }
`;
